var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{style:({ background: _vm.$vuetify.theme.themes[_vm.theme].background })},[_c('appdrawer'),_c('appbar'),_c('v-main',[_c('v-container',{staticClass:"pages"},[(_vm.isLoading())?_c('div',[_c('v-progress-linear',{attrs:{"indeterminate":""}})],1):_vm._e(),_c('router-view',{key:_vm.$route.path})],1)],1),_c('appfooter'),_c('bottonnav')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }